import { VesselData } from './vessel-data.model';
import { Net } from './net.model';
import { Logbook } from './logbook.model';
import { Tel } from '../../tel-input/tel-input.component';
import { ValidationService } from '../../services/validation.service';

export class UserData {

  passedPrivacyNotice: boolean = false;

  hasDisabledPrivacyNotice: boolean = false;

  // Email for signup
  userEmail: string = ''; // will eventually need to ensure this is unique

  firstName: string = '';

  lastName: string = '';

  apiKey: string = '';

  fin: string = '';

  passwordHash: string = '';

  address: string = '';

  city: string = '';

  postalCode: string = '';

  phoneNum: Tel = new Tel();

  // current homepage
  currHomepage: string = '';

  // saved user vessels
  vessels: VesselData[] = [];

  // saved nets
  nets: Net[] = [];

  // purchased logbooks
  logbooks: Logbook[] = [];

  //admin use, the user the admin has replicated,
  adminReplicated: string = ''

  constructor(email: string = '') {
    this.userEmail = email;
  }

  public toString(): string {
    return this.userEmail;
  }

  public isValid(): boolean {
    return !!this.userEmail;
  }

  // transform object to User Data
  public static transformAnonymous(user: any): UserData {
    let thisUser: UserData = new UserData();
    thisUser.passedPrivacyNotice = user.passedPrivacyNotice ?? false;
    thisUser.hasDisabledPrivacyNotice = user.hasDisabledPrivacyNotice ?? false;
    thisUser.userEmail = user.userEmail;
    thisUser.passwordHash = user.passwordHash ?? '';
    thisUser.firstName = user.firstName ?? '';
    thisUser.lastName = user.lastName ?? '';
    thisUser.apiKey = user.apiKey ?? '';
    thisUser.fin = user.fin ?? '';
    thisUser.address = user.address ?? '';
    thisUser.city = user.city ?? '';
    thisUser.postalCode = user.postalCode ?? '';
    thisUser.phoneNum = Tel.transformAnonymous(user.phoneNum);
    thisUser.logbooks = Logbook.transformAnonArray(user.logbooks);
    thisUser.vessels = VesselData.transformAnonArray(user.vessels);
    thisUser.nets = Net.transformAnonArray(user.nets);
    thisUser.currHomepage = ValidationService.validateHomepage(user.currHomepage);
    return thisUser;
  }

}
